import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-gallery').each((index, gallery) => {
  const $gallery = $(gallery);
  const $galleryFlickity = $gallery.find('.js-gallery-flickity');
  const $galleryFigure = $gallery.find('.js-gallery-figure');
  const $galleryPosition = $gallery.find('.js-gallery-position');
  const $galleryCaption = $gallery.find('.js-gallery-caption');

  $galleryFlickity.flickity({
    arrowShape: `M20.92,55.94l28.61,28.63-7.56,7.43L0,50,41.97,8l7.56,7.56-28.61,28.5h79.08v11.89s-79.08,0-79.08,0Z`,
    contain: true,
    draggable: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
  });

  $galleryFlickity.on('change.flickity', function (event, index) {
    $galleryPosition.text(`${index + 1}/${$galleryFigure.length}`);
    const caption = $galleryFigure.eq(index).attr('data-caption') || '';
    $galleryCaption.text(caption);
  });
});
